export const getGroupsList = async (service, org_id) => {
    const groups = await service.get(`/org/invitation/groups${org_id ? `?org_id=${org_id}` : ""}`);
    return groups;
  };